module.exports = __webpack_public_path__ + "img/bg.cd1a7c50.webp";